import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Link,
  Grid,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Logo from "../assets/landing/Plumerialogo.png"; // adjust the path if needed

const Footer = () => {
  return (
    <Box bgcolor="#fff" sx={{ margin: "0 auto", width: "100%" }} py={4}>
      <Box
        sx={{
          borderRight: {
            md: "1px solid #EAEAEA", // Applies border only for medium and up screens
          },
        }}
      >
        <Grid
          container
          spacing={4}
          justifyContent={{ xs: "center", md: "space-between" }}
          width={{ xl: "60%", lg: "80%", md: "85%", sm: "90%", xs: "95%" }}
          margin="auto"
          sx={{
            borderBottom: {
              xs: "1px solid #EAEAEA",
            },
          }}
          pb={2}
        >
          {/* Left Side (Logo and Links) */}
          <Grid
            item
            xs={12}
            md={4}
            textAlign="left" // Ensures left alignment on larger screens
            alignSelf="center"
            sx={{
              borderRight: {
                md: "1px solid #EAEAEA", // Applies border only for medium and up screens
              },
              height: "100%", // Ensures the border spans the full height of the section
              paddingRight: {
                md: 1, // Optional: Adds some space on the right side for better appearance
              },
              py: {
                md: 4,
              },
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box mb={2}>
              <img src={Logo} alt="Durham Plumeria" style={{ maxWidth: 200 }} />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              mb={1}
            >
              <LocationOnIcon color="success" sx={{ mr: 1 }} />
              <Typography color="#232323">Parkland, Florida</Typography>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="flex-start">
              <FacebookIcon color="success" sx={{ mr: 1 }} />
              <Typography color="#232323">Follow Us on Facebook</Typography>
            </Box>
          </Grid>

          {/* Center Navigation (Links Section) */}
          <Grid
            item
            xs={12}
            md={2}
            textAlign="left" // Aligns the links to the left on all screen sizes
            alignSelf="center"
          >
            <Box display="flex" flexDirection="column" gap={3}>
              <Link
                href="#"
                sx={{
                  color: "#232323",
                  textAlign: "center",
                  textDecoration: "none",
                  "&:hover": { color: "#31B44B" },
                }}
              >
                HOME
              </Link>
              <Link
                href="#"
                sx={{
                  color: "#232323",
                  textAlign: "center",
                  textDecoration: "none",
                  "&:hover": { color: "#31B44B" },
                }}
              >
                ABOUT US
              </Link>
              <Link
                href="#"
                sx={{
                  color: "#232323",
                  textAlign: "center",
                  textDecoration: "none",
                  "&:hover": { color: "#31B44B" },
                }}
              >
                OUR NURSERY
              </Link>
              <Link
                href="#"
                sx={{
                  color: "#232323",
                  textAlign: "center",
                  textDecoration: "none",
                  "&:hover": { color: "#31B44B" },
                }}
              >
                SHOP
              </Link>
              <Link
                href="#"
                sx={{
                  color: "#232323",
                  textAlign: "center",
                  textDecoration: "none",
                  "&:hover": { color: "#31B44B" },
                }}
              >
                CONTACT US
              </Link>
            </Box>
          </Grid>

          {/* Right Side (Contact Form) */}
          <Grid width={{ xs: "100%", md: "auto" }}>
            <Box
              component="form"
              display="flex"
              flexDirection="column"
              gap={1}
              sx={{ width: { xs: "100%", sm: "100%", md: "auto" } }} // Ensures 100% width on mobile/tablet
            >
              <TextField
                variant="outlined"
                placeholder="Name"
                fullWidth
                size="small"
              />
              <Box display="flex" gap={1}>
                <TextField
                  variant="outlined"
                  placeholder="Email"
                  fullWidth
                  size="small"
                />
                <TextField
                  variant="outlined"
                  placeholder="Phone Number"
                  fullWidth
                  size="small"
                />
              </Box>
              <TextField
                variant="outlined"
                placeholder="How Can We Help You"
                multiline
                rows={3}
                fullWidth
                size="small"
                InputProps={{
                  sx: { "& textarea": { resize: "vertical" } },
                }}
              />
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#4caf50",
                  borderRadius: 0,
                  width: { xs: "50%", sm: "30%", md: "40%" },
                  padding: "6px 16px",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    bgcolor: "#202020",
                    color: "#31B44B",
                  },
                }}
              >
                SEND MESSAGE
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Bottom copyright */}
      <Box textAlign="center" mt={2}>
        <Typography variant="body2" color="textSecondary">
          All Rights Reserved © Durham Plumeria
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
